<template>
  <div class="select-container">
    <label :for="componentID" class="label">{{ label }}</label>
    <select class="select" @change="onSelect">
      <option
        v-for="item in options"
        :key="item.value"
        :value="item.value"
        class="option"
        :selected="item.selected"
        :id="componentID"
        >{{ item.text }}</option
      >
    </select>
  </div>
</template>

<script>
export default {
  props: {
    componentID: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ""
    }
  },
  methods: {
    onSelect(e) {
      this.$emit("handleSelect", e.target.value);
      this.$emit("input", e.target.value);
    }
  }
};
</script>

<style scoped>
.select-container {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 15px;
  color: #ffffff;
}

.select {
  margin-top: 10px;
  padding: 10px 15px;
  font-size: 15px;
  color: #222c44;
  text-align: center;
  border-radius: 5px;
  outline: none;
  box-sizing: border-box;
}

.option {
  color: #000000;
  background-color: #ffffff;
}
</style>
